import type { FeatureFlags } from '.';

export const initFeatureFlags = (flags: FeatureFlags) => {
  return Object.entries(flags).reduce((acc, [flag, value]) => {
    if (value !== undefined) {
      if (value) {
        window.localStorage.setItem(flag, JSON.stringify(value));
      } else {
        window.localStorage.removeItem(flag);
      }
    }

    const storedValue = window.localStorage.getItem(flag);

    return {
      ...acc,
      [flag]: storedValue ? JSON.parse(storedValue) : undefined,
    };
  }, {} as FeatureFlags);
};
